import Message from './MessageClass'

export default class Inbox extends Message {
  constructor (rawData = {}) {
    super(rawData)
  }
}



// WEBPACK FOOTER //
// ./src/models/chat/InboxClass.js